<template>
	<el-drawer title="话术配置" :visible.sync="dialogVisible" size="60%" :modal-append-to-body="false" direction="rtl" :wrapperClosable="false" class="customer-drawer-common add-edit-words" :destroy-on-close="true" :show-close="false">
		<el-form ref="form" :model="listQuery" :rules="listQueryRules" label-width="80px">
			<el-form-item :label="item.name"  v-for="(item,index) in select_arrs" :key="index" :prop="item.val">
				<el-select v-model="listQuery[item.val]" clearable placeholder="请选择" style="width:300px">
				<el-option v-for="(_item,_index) in item.options" :key="_index" :label="_item[item.label]"
					:value="_item[item.value]"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="话术" class="customer-form-item">
				<section class="textarea">
					<div>
						<el-button  icon="el-icon-plus" @click="insertLink">插入链接</el-button>
					</div>
					<div class="input">
						<customerInput :otherMsg="otherMsg" @customerInputEvent="customerInputEvent"></customerInput>	
					</div>

				</section>
				<section class="params">
					<span>插入参数：</span>
					<div>
						<el-popover v-for="(item,index) in params" :key="index"
							placement="left"
							width="200"
							trigger="hover"
							:content="item.desc">
							<span :class="{'active':active == index}" slot="reference" @click.stop="toChooseParams(item)">{{item.paramName}}</span>
						</el-popover>
					</div>
				</section>
			</el-form-item>
		</el-form>
		<div class="desc">
			<p>* 友情提示：</p>
			<!-- <p>1.请谨慎修改系统话术，否则可能会导致系统功能无法正常使用</p> -->
			<p>话术优先级: 技能组 > 渠道 > 品牌</p>
		</div>
		<div class="footer">
			<el-button @click="onClose" size="mini">返 回</el-button>
			<el-button type="primary" size="mini" @click="onSave" :loading="loading">{{ loading ? '提交中 ...' : '保 存' }}
			</el-button>
		</div>
		<el-drawer size="30%" :title="innerTitle" :modal-append-to-body="false" :visible.sync="innerVisible"  :append-to-body="true" :wrapperClosable="false" 
			class="customer-drawer-common">
			<el-form ref="innerForm" :model="innerForm" :rules="innerRules" label-width="80px">
					<el-form-item label="URL" prop="url">
					<el-input v-model="innerForm.url" placeholder="请输入URL" :disabled="innerTitle == '满意度链接'"></el-input>
					</el-form-item>
					<el-form-item label="文本:">
						<el-input type="textarea" resize="none" :rows="5" v-model="innerForm.desc" placeholder="请输入文本"></el-input>
					</el-form-item>
			</el-form>
			<div class="footer">
				<el-button @click="innerVisible = false" size="mini">取 消</el-button>
				<el-button type="primary" size="mini" @click="onInnerSave" :loading="loadingInner">{{ loadingInner ? '提交中 ...' : '确 定' }}
				</el-button>
			</div>
		</el-drawer>
	</el-drawer>
</template>

<script>
	import { isUrl } from '@/utils/functions'
	import customerInput from './customerInput.vue'
	export default {
		props:['options','msgTypes'],
		components:{
			customerInput
		},
		data(){
			var validateUrl = (rule, value, callback) => {
					if (value === '') {
						callback(new Error('请输入URL'));
					} else {
						if(this.innerTitle  == '满意度链接') {
							callback();
						}else {
							if(isUrl(value)){
								callback()
							}else {
								callback("请输入正确得url")
							}
							
						}
						
					}
			};
			return {
				loading:false,
				loadingInner:false,
				dialogVisible:false,
				innerTitle:'链接',
				innerVisible:false,
				select_arrs:[
					{ name: "子品牌", val: "childBrand", options: [],value:'id',label:'name'},
					{ name: "话术类型", val: "msgType", options:[],value:'id',label:'name'},
					{ name: "技能组", val: "skillGroup", options: [],value:'id',label:'name' },
					{ name: "渠道", val: "channel", options: [] ,value:'id',label:'name'}
				],
				listQuery:{
					childBrand:'',
					msgType:'',
					skillGroup:'',
					channel:'',
					holidayMsg:'',
					brand:this.$store.state.user.brandId,
					id:''
				},
				listQueryRules:{
					childBrand:[{ required: true, message: '请选择子品牌', trigger: 'change' }],
					msgType:[{ required: true, message: '请选择话术类型', trigger: 'change' }],
					holidayMsg:[{ required: true, message: '请填写话术', trigger: 'blur' }],
					//skillGroup:[{ required: true, message: '请选择技能组', trigger: 'change' }],
					//channel:[{ required: true, message: '请选择渠道', trigger: 'change' }]
				},
				active:-1,
				params:[],
				innerForm:{
					url:'',
					desc:''
				},
				innerRules:{
					url:[ {validator: validateUrl, trigger: 'blur' }]
					
				},
				paramsTips:[
					{
						key:'坐席昵称',
						desc:'您好，感谢您关注，客服${agent}很高兴为您服务！',
						type:'${agent}',
					},
					{
						key:'客服昵称',
						desc:'尊贵的用户${user} 您好，当前为非工作时间，请留言，我们将在服务时间内尽快回复您。',
						type:'${customer}',
					},
					{
						key:'排队人数',
						desc:'您好，由于目前咨询量集中，您是第${nums}位排队客人，请您耐心等待。',
						type:'${nums}',
					},
					{
						key:'满意度地址',
						desc:'为文本提供满意度地址超链接。',
						type:'${link}',
					}
					
				],
				holidayMsgParam:'',
				otherMsg:'',
				tips:'新增'
				
			}
		},
		methods:{
			customerInputEvent(val){
				if(!val){
					this.holidayMsgParam = ''
				}
				this.listQuery.holidayMsg = val
			},
			onSave(){
				this.$refs.form.validate((valid) => {
					if(valid) {
						this.loading = true
						let params = Object.assign({},this.listQuery);
						if(this.holidayMsgParam){
							params.holidayMsgParam = this.holidayMsgParam
						}
						this.$api.saveSystemWordsListsItem(params).then(res => {
							if(res.errcode == 0){
								this.loading = false
								this.$message.success(`${this.tips}成功`);
								this.$emit("getData");
								this.dialogVisible = false
							}else {
								this.loading = false
							}
						})
					}
				})
			},
			onClose(){
				this.dialogVisible = false;
				this.otherMsg = ''
			},
			onInnerSave(){
				this.$refs.innerForm.validate((valid) => {
					if(valid) {
						this.innerVisible = false;
						let text = this.innerForm.desc ? this.innerForm.desc : this.innerForm.url;
						this.otherMsg = '<a href=' + this.innerForm.url + ' target="_blank" style="color:#337EFF;text-decoration: underline;">' + text+ '</a>'
					}
				})
			},
			openAddEdit(row){
				this.getParams();
				this.dialogVisible = true;
				this.tips = row ? '修改' : '新增';
				this.otherMsg = ''
				this.$nextTick(()=>{
					this.resetForm();
					this.select_arrs.map((item,index) => {
						this.options.map(_item => {
							if(item.val == _item.model && item.val != 'msgType') {
								this.select_arrs[index].options = _item.list;
							}
							if(item.val == 'msgType'){
								this.select_arrs[index].options = this.msgTypes
							}
						})
					})
					if(row) {
						this.getDetaild(row.id)
					}
				})
			},
			resetForm(){
				let keys = Object.keys(this.listQuery);
				keys.map(item => {
					this.listQuery[item] = ''
				})
				this.listQuery.brand = this.$store.state.user.brandId
				this.$refs.form.clearValidate()
			},
			getDetaild(id){
				this.$api.getSystemWordsListsItem(id).then(res => {
					if(res.errcode == 0) {
						this.holidayMsgParam = res.data.holidayMsgParam || '';
						let keys = Object.keys(this.listQuery);
						this.otherMsg = res.data.holidayMsg
						keys.map(item => {
							this.listQuery[item] = res.data[item]
						})
					}
				})
			},
			toChooseParams(row){
				this.holidayMsgParam = row
				if(row.paramName.indexOf('满意度') > -1) {
					this.innerTitle = '满意度链接';
					this.innerVisible = true;
					this.innerForm.url = '${link}';
					this.innerForm.desc = ''
				}else{
					this.otherMsg = row.paramValue || ''
				}
			},
			//插入链接
			insertLink(){
				this.innerTitle = '链接';
				this.innerVisible = true;
				this.$nextTick(()=> {
					this.innerForm.url = '';
					this.innerForm.desc = ''
				})
			},
			async getParams(){
				await this.$api.getSystemWordsParams().then(res => {
					if(res.errcode == 0){
						this.params = res.data
					}
				})
			},
			
		},
	}
</script>

<style lang="scss">
	.add-edit-words {
		.el-form {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			
		}
		.customer-form-item {
			width: 100%;
			
			.el-form-item__content {
				width: calc(100% - 80px);
				display: flex;
				justify-content: space-between;
				margin-left: 0 !important;
				
				.textarea {
					width: 60%;
					.input {
						height: 174px;
						margin-top: 10px;
					}
				}
				.params {
					width: 35%;
					>div{
						border-radius: 4px;
						border: 1px solid #D8D8D8;
						padding: 10px;
						margin-top: 10px;
						height: 174px;
						overflow-y: scroll;
						span {
							display: block;
							cursor: pointer;
							color: #3C4353;
							line-height: 22px;
							&:hover,&.active{
								color: #337EFF;
								background-color: #F2F8FF;
							}
						}
					}
				}
			}
		}
		.desc {
			color: #FF504D;
			font-size: 14px;
			line-height: 24px;
			padding-left: 80px;
		}
	}
</style>
